export const getDevData = (array) => {
  let newDevArray = [...array];
  let devData = {
    totalCount: newDevArray.length,
    males: 0,
    females: 0,
    noGender: 0,
  };
  newDevArray?.forEach((dev) => {
    // console.log(dev.gender);
    if (dev.gender === "Female") {
      devData.females += 1;
    } else if (dev.gender === "Male") {
      devData.males += 1;
    } else {
      dev.noGender += 1;
    }
  });
  //call devCalc here and return its return value
  return devCalc(devData);
};

const devCalc = (devObj) => {
  const newStats = {
    total: devObj.totalCount,
    males: (devObj.males / devObj.totalCount) * 100,
    females: (devObj.females / devObj.totalCount) * 100,
  };
  return newStats;
};

export const ticketCalc = (array) => {
  const newArray = [...array];
  let tickets = {
    total: array.length,
    pending: 0,
    completed: 0,
  };

  newArray.forEach((ticket) => {
    if (ticket.closed === false) {
      tickets.pending += 1;
    } else if (ticket.closed === true) {
      tickets.completed += 1;
    }
  });
  // console.log(tickets);
  return tickets;
};

export const jobCalc = (jobs, developers) => {
  let jobStats = {
    total: jobs.length,
    appliedJobs: 0,
  };
  developers.forEach((dev) => {
    if (dev.appliedJobs.length > 0) {
      jobStats.appliedJobs += dev.appliedJobs.length;
    }
  });
  return jobStats;
};
